/**
 * Global toast host for uiSlice.notifications
 */
import { useEffect } from 'react';
import { Snackbar, Alert, Stack } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { removeNotification } from '../store/slices/uiSlice';

const AUTO_HIDE_MS = 4500;

const NotificationHost: React.FC = () => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector((s) => s.ui.notifications);
  // Show newest 3 stacked
  const visible = notifications.slice(-3);

  useEffect(() => {
    if (notifications.length === 0) return;
    const timers = notifications.map((n) =>
      window.setTimeout(() => {
        dispatch(removeNotification(n.id));
      }, AUTO_HIDE_MS)
    );
    return () => {
      timers.forEach((t) => window.clearTimeout(t));
    };
  }, [notifications, dispatch]);

  if (visible.length === 0) return null;

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        bottom: 40,
        right: 16,
        zIndex: 10000,
        maxWidth: 400,
        pointerEvents: 'none',
      }}
    >
      {visible.map((n) => (
        <Snackbar
          key={n.id}
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'static', pointerEvents: 'auto' }}
        >
          <Alert
            severity={n.type}
            variant="filled"
            onClose={() => dispatch(removeNotification(n.id))}
            sx={{ width: '100%', boxShadow: 4 }}
          >
            {n.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default NotificationHost;
